import { render, staticRenderFns } from "./SupplierViewLogs.vue?vue&type=template&id=023d6189"
import script from "./SupplierViewLogs.vue?vue&type=script&lang=js"
export * from "./SupplierViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports